import React, { useState } from "react";
import tata from '../images/company/tata'
import mahindra from '../images/company/mahindra'
import pagariya from '../images/company/pagariya'
import trenz from '../images/company/trenz'
import usha from '../images/company/usha'
import money_roots from '../images/company/money_roots'
import target_1 from '../images/target_1'
// import team_1 from '../images/team/team_1'
import team_1 from '../images/team/team_1'
import { Link } from "react-router-dom";

export default function StrategicPlanning() {

  const [isVisible, setIsVisible] = useState(true);
  const [fadeInUp, setfadeInUp] = useState(true)


  return (
    <>
      <div class="page-wrapper sec-mar">
        <article
          id="post-3040"
          class="post-3040 page type-page status-publish hentry"
        >
          <div class="inner-post">
            <div
              data-elementor-type="wp-page"
              data-elementor-id="3040"
              class="elementor elementor-3040"
            >
              {/* </div> */}
            </div>
          </div>
        </article>
      </div>

      <section
        class="elementor-section elementor-top-section elementor-element elementor-element-4fb7eb7 elementor-section-full_width elementor-section-height-default elementor-section-height-default"
        data-id="4fb7eb7"
        data-element_type="section"
      >
        <div class="elementor-container elementor-column-gap-no">
          <div
            class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-d20edb3"
            data-id="d20edb3"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-a10d9e7 elementor-widget elementor-widget-spinner_slider"
                data-id="a10d9e7"
                data-element_type="widget"
                data-widget_type="spinner_slider.default"
              >
                <div class="elementor-widget-container">
                  <div class="banner-section4">
                    <img
                      decoding="async"
                      src="https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/09/banner4-wave1.svg"
                      class="banner4-wave1 img-fluid"
                      alt="image"
                    />
                    <img
                      decoding="async"
                      src="https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/09/banner4-wave2.svg"
                      class="banner4-wave2 img-fluid"
                      alt="image"
                    />
                    <img
                      decoding="async"
                      src="https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/09/banner4-spring.svg"
                      class="banner4-spring img-fluid"
                      alt="image"
                    />
                    <img
                      decoding="async"
                      src="https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/09/banner4-dot-square.svg"
                      class="banner4-dot-sq img-fluid"
                      alt="image"
                    />

                    <a href="#aaaa" class="go-down-btn"></a>
                    <div class="container">
                      <div class="row justify-content-center align-items-center">
                        <div class="col-lg-7">
                          <div
                            class="banner-content style-2 wow fadeInLeft"
                            data-wow-duration="1.5s"
                            data-wow-delay="0.2s"
                          >
                            <span>Welcome to Our Agency</span>
                            <h1>Top Notch Mediaworks Ltd</h1>
                            <p class="para">
                             We Make Name a Brand
                            </p>

                            <div class="button-group gap-5">
                              <a
                                href="#"
                                class="eg-btn btn--primary  btn--lg"
                              >
                                Discover More
                              </a>
                              
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-5 position-relative">
                          <img
                            decoding="async"
                            src="https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/09/banner4-circel1.svg"
                            class="banner4-circel1"
                            alt="image"
                          />
                          <img
                            decoding="async"
                            src="https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/09/banner4-circel2.svg"
                            class="banner4-circel2"
                            alt="image"
                          />
                          <div class="banner4-img">
                            <img
                              decoding="async"
                              // src="https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/09/banner4-bg-1.png"
                              src={team_1}
                              alt="image"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        class="elementor-section elementor-top-section elementor-element elementor-element-fe811f7 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="fe811f7"
        data-element_type="section"
      >
        <div class="elementor-container elementor-column-gap-default">
          <div
            class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-34ef824"
            data-id="34ef824"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-11f7dec elementor-widget elementor-widget-spinner_clients"
                data-id="11f7dec"
                data-element_type="widget"
                data-widget_type="spinner_clients.default"
              >
                <div class="elementor-widget-container">
                  <script></script>

                  {/* <div class="sponsor-section4">
                    <div class="sponsor-wrapper">
                      <div class="row justify-content-center gap-lg-0 gap-5">
                        <div class="col-lg-2 col-md-3 col-sm-3 col-4">
                          <div
                            class="brand-item wow fadeInUp"
                            data-wow-duration="1.5s"
                            data-wow-delay=".2s"
                            style={{
                              visibility: isVisible ? 'visible' : 'hidden',
                              animationDuration: 1.5,
                              animationDelay: 0.2,
                              animationName: fadeInUp,
                            }}
                          >
                        
                            <img src={tata} alt="" style={{height:"90px", width:"90px" }} />
                          </div>
                        </div>
                        <div class="col-lg-2 col-md-3 col-sm-3 col-4">
                          <div
                            class="brand-item wow fadeInUp"
                            data-wow-duration="1.5s"
                            data-wow-delay=".2s"
                            style={{
                              visibility: isVisible ? 'visible' : 'hidden',
                              animationDuration: 1.5,
                              animationDelay: 0.2,
                              animationName: fadeInUp,
                            }}
                          >
                          
                            <img src={mahindra} alt="" 
                            style={{height:"90px", width:"90px" }}
                            />

                          </div>
                        </div>
                        <div class="col-lg-2 col-md-3 col-sm-3 col-4">
                          <div
                            class="brand-item wow fadeInUp"
                            data-wow-duration="1.5s"
                            data-wow-delay=".2s"
                            style={{
                              visibility: isVisible ? 'visible' : 'hidden',
                              animationDuration: 1.5,
                              animationDelay: 0.2,
                              animationName: fadeInUp,
                            }}
                          >
                           
                         <img src={pagariya} alt="" style={{height:"50px", width:"150px" }} />

                          </div>
                        </div>
                        <div class="col-lg-2 col-md-3 col-sm-3 col-4">
                          <div
                            class="brand-item wow fadeInUp"
                            data-wow-duration="1.5s"
                            data-wow-delay=".2s"
                            style={{
                              visibility: isVisible ? 'visible' : 'hidden',
                              animationDuration: 1.5,
                              animationDelay: 0.2,
                              animationName: fadeInUp,
                            }}
                          >
                            
                        <img src={usha} alt="" style={{height:"90px", width:"90px" }} />

                          </div>
                        </div>
                        <div class="col-lg-2 col-md-3 col-sm-3 col-4">
                          <div
                            class="brand-item wow fadeInUp"
                            data-wow-duration="1.5s"
                            data-wow-delay=".2s"
                            style={{
                              visibility: isVisible ? 'visible' : 'hidden',
                              animationDuration: 1.5,
                              animationDelay: 0.2,
                              animationName: fadeInUp,
                            }}
                          >
                           

<img src={trenz} alt="" style={{height:"90px", width:"90px" }} />

                          </div>
                        </div>
                        <div class="col-lg-2 col-md-3 col-sm-3 col-4">
                          <div
                            class="brand-item wow fadeInUp"
                            data-wow-duration="1.5s"
                            data-wow-delay=".2s"
                            style={{
                              visibility: isVisible ? 'visible' : 'hidden',
                              animationDuration: 1.5,
                              animationDelay: 0.2,
                              animationName: fadeInUp,
                            }}
                          >
                          

<img src={money_roots} alt="" style={{height:"90px", width:"120px" }} />

                          </div>
                        </div>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

{/* main section */}

<div className="container">
  <div className="row text-center">
    <h1><b>STRATEGIC PLANNING
</b></h1>
<p>They work at turtle pace and are fragmented by the narrow discipline-oriented point of view. Top Notch Media Works do the same planning for your business
</p>
  </div>
</div>


<section
        class="mt-4 elementor-section elementor-top-section elementor-element elementor-element-8ee92bb elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="8ee92bb"
        data-element_type="section"
        data-settings='{"background_background":"classic"}'
      >
        <div class="elementor-container elementor-column-gap-default">
          <div
            class=" elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-b9a4717"
            data-id="b9a4717"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-cb648cc elementor-widget elementor-widget-spinner_heading"
                data-id="cb648cc"
                data-element_type="widget"
                data-widget_type="spinner_heading.default"
              >
                <div class="elementor-widget-container">
                  <div class="section-title  primary4 position-relative">
                    <span>-Strategic Planning
-</span>
                    <h3 className="text-light">
                    Market Study & Survey

                    </h3>
                    <p class="para mb-0 ">
                    Many big agencies’ strategic departments resemble a scary Tower of Babel: flooded with data, confronted by hyper-specialized jargons and unable to create unifying brand metrics.
                    </p>
                  </div>
                </div>
              </div>
    
              <div
                class="elementor-element elementor-element-4ca47ad elementor-widget elementor-widget-spinner_button text-center"
                data-id="4ca47ad"
                data-element_type="widget"
                data-widget_type="spinner_button.default"
              >
                <div class="elementor-widget-container">
                  <div
                    class="about1-content wow fadeInLeft"
                    data-wow-duration="1.5s"
                    data-wow-delay="0.2s"
                  >
                    <a href="tel:9158111116" class="eg-btn btn--primary btn--lg">
                     
                     Contact Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-1000224"
            data-id="1000224"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-389eeb3 elementor-widget elementor-widget-spinner_about"
                data-id="389eeb3"
                data-element_type="widget"
                data-widget_type="spinner_about.default"
              >
                <div class="elementor-widget-container">
                  <div class="order-lg-2 order-1">
                    <div
                      class="about-images wow fadeInRight"
                      data-wow-duration="1.5s"
                      data-wow-delay="0.2s"
                    >
                      <div class="row g-0">
                        <div class="col-6 about11">
                       
                        </div>
                     
                        <img src="https://thumbs.dreamstime.com/b/market-research-marketing-strategy-business-technology-internet-concept-market-research-marketing-strategy-business-technology-118756840.jpg" alt="" />
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


{/* /target Analysis */}
<section
        class="mt-4 elementor-section elementor-top-section elementor-element elementor-element-8ee92bb elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="8ee92bb"
        data-element_type="section"
        data-settings='{"background_background":"classic"}'
      >
        <div class="elementor-container elementor-column-gap-default">
         
          <div
            class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-1000224"
            data-id="1000224"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-389eeb3 elementor-widget elementor-widget-spinner_about"
                data-id="389eeb3"
                data-element_type="widget"
                data-widget_type="spinner_about.default"
              >
                <div class="elementor-widget-container">
                  <div class="order-lg-2 order-1">
                    <div
                      class="about-images wow fadeInLeft"
                      data-wow-duration="1.5s"
                      data-wow-delay="0.2s"
                    >
                      <div class="row g-0">
                        <div class="col-6 about11">
                         
                        </div>
                        
                        <img src={target_1} alt="" />
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div
            class=" elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-b9a4717"
            data-id="b9a4717"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-cb648cc elementor-widget elementor-widget-spinner_heading"
                data-id="cb648cc"
                data-element_type="widget"
                data-widget_type="spinner_heading.default"
              >
                <div class="elementor-widget-container">
                  <div class="section-title  primary4 position-relative">
                    <span>-Target Analysis

-</span>
                    <h3 className="text-light">
                    Target Analysis


                    </h3>
                    <p class="para mb-0 ">
                    One of the most powerful tools of small business marketing strategy is defining and addressing your target market—the audience that you think is most likely to buy your product or service.</p>
                  </div>
                </div>
              </div>
              
              <div
                class="elementor-element elementor-element-4ca47ad elementor-widget elementor-widget-spinner_button text-center"
                data-id="4ca47ad"
                data-element_type="widget"
                data-widget_type="spinner_button.default"
              >
                <div class="elementor-widget-container">
                  <div
                    class="about1-content wow fadeInLeft"
                    data-wow-duration="1.5s"
                    data-wow-delay="0.2s"
                  >
                    <a href="tel:9158111116" class="eg-btn btn--primary btn--lg">
                     
                     Contact Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

{/* POC Creation */}

      <section
        class="mt-4 elementor-section elementor-top-section elementor-element elementor-element-8ee92bb elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="8ee92bb"
        data-element_type="section"
        data-settings='{"background_background":"classic"}'
      >
        <div class="elementor-container elementor-column-gap-default">
          <div
            class=" elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-b9a4717"
            data-id="b9a4717"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-cb648cc elementor-widget elementor-widget-spinner_heading"
                data-id="cb648cc"
                data-element_type="widget"
                data-widget_type="spinner_heading.default"
              >
                <div class="elementor-widget-container">
                  <div class="section-title  primary4 position-relative">
                    <span>-POC Creation

-</span>
                    <h3 className="text-light">
                    POC Creation
                    </h3>
                    <p class="para mb-0 ">
                    A proof of concept (POC) is an exercise in which work is focused on determining whether an idea can
                     be turned into a reality. A proof of concept is meant to determine the feasibility of the idea or to verify that the idea will function as envisioned. It is sometimes also known as proof of principle.


                    </p>
                  </div>
                </div>
              </div>
    
              <div
                class="elementor-element elementor-element-4ca47ad elementor-widget elementor-widget-spinner_button text-center"
                data-id="4ca47ad"
                data-element_type="widget"
                data-widget_type="spinner_button.default"
              >
                <div class="elementor-widget-container">
                  <div
                    class="about1-content wow fadeInLeft"
                    data-wow-duration="1.5s"
                    data-wow-delay="0.2s"
                  >
                    <a href="tel:9158111116" class="eg-btn btn--primary btn--lg">
                     
                     Contact Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-1000224"
            data-id="1000224"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-389eeb3 elementor-widget elementor-widget-spinner_about"
                data-id="389eeb3"
                data-element_type="widget"
                data-widget_type="spinner_about.default"
              >
                <div class="elementor-widget-container">
                  <div class="order-lg-2 order-1">
                    <div
                      class="about-images wow fadeInRight"
                      data-wow-duration="1.5s"
                      data-wow-delay="0.2s"
                    >
                      <div class="row g-0">
                        <div class="col-6 about11">
                       
                        </div>
                     
                        <img src="https://www.netsolutions.com/insights/wp-content/uploads/2022/11/POC-vs.-MVP-vs.-Prototype.webp" alt="" />
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* /policy making */}
<section
        class="mt-4 elementor-section elementor-top-section elementor-element elementor-element-8ee92bb elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="8ee92bb"
        data-element_type="section"
        data-settings='{"background_background":"classic"}'
      >
        <div class="elementor-container elementor-column-gap-default">
         
          <div
            class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-1000224"
            data-id="1000224"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-389eeb3 elementor-widget elementor-widget-spinner_about"
                data-id="389eeb3"
                data-element_type="widget"
                data-widget_type="spinner_about.default"
              >
                <div class="elementor-widget-container">
                  <div class="order-lg-2 order-1">
                    <div
                      class="about-images wow fadeInLeft"
                      data-wow-duration="1.5s"
                      data-wow-delay="0.2s"
                    >
                      <div class="row g-0">
                        <div class="col-6 about11">
                         
                        </div>
                        
                        <img src="https://thumbs.dreamstime.com/b/internet-information-technology-businessman-hand-showing-concept-75784736.jpg" alt="" />
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div
            class=" elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-b9a4717"
            data-id="b9a4717"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-cb648cc elementor-widget elementor-widget-spinner_heading"
                data-id="cb648cc"
                data-element_type="widget"
                data-widget_type="spinner_heading.default"
              >
                <div class="elementor-widget-container">
                  <div class="section-title  primary4 position-relative">
                    <span>-Policy Making


-</span>
                    <h3 className="text-light">
                    Policy Making



                    </h3>
                    <p class="para mb-0 ">
                    its decisions that are intended to solve problems and improve the quality of life for its citizens. A policy established and carried out by the government goes through several stages from inception to conclusion.</p>
                  </div>
                </div>
              </div>
              
              <div
                class="elementor-element elementor-element-4ca47ad elementor-widget elementor-widget-spinner_button text-center"
                data-id="4ca47ad"
                data-element_type="widget"
                data-widget_type="spinner_button.default"
              >
                <div class="elementor-widget-container">
                  <div
                    class="about1-content wow fadeInLeft"
                    data-wow-duration="1.5s"
                    data-wow-delay="0.2s"
                  >
                    <a href="tel:9158111116" class="eg-btn btn--primary btn--lg">
                     
                     Contact Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
